export default "__VITE_ASSET__aa81a8a1__"